import { render, staticRenderFns } from "./Sublimated.vue?vue&type=template&id=049024af&scoped=true&"
import script from "./Sublimated.vue?vue&type=script&lang=js&"
export * from "./Sublimated.vue?vue&type=script&lang=js&"
import style0 from "./Sublimated.vue?vue&type=style&index=0&id=049024af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049024af",
  null
  
)

export default component.exports